export default __webpack_public_path__ + "static/media/sc.44e67156.svg";